import React, { useEffect, useState } from "react";
import "../../UserSetting/toggle-css.css";
import styles from "../settings.module.css";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import countryList from "react-select-country-list";
import Select from "../../../../../components/CustomSelect/Select";
import { editInvoiceSettings } from "../../../../../general_redux/general settings/actions";
import * as Yup from 'yup';


function Invoice() {
  const findArray = (val) => {
    const ar = countryList()
      .getData()
      .filter((row) => row.label === val);
    if (ar.length !== 0) {
      return ar[0];
    }
  };
  const { setting } = useSelector(({ generalSetting }) => generalSetting && generalSetting);
  
  const dispatch = useDispatch();
  
  const [invoiceDate, setInvoiceDate] = useState(
    setting && setting.invoiceDueDate ? setting.invoiceDueDate : 0
  );
  const [invoiceSenderName, setInvoiceSenderName] = useState(setting.senderName ? setting.senderName : "");
  const [invoiceAddress1, setInvoiceAddress1] = useState(
    setting.address1 ? setting.address1 : ""
  );
  const [invoiceAddress2, setInvoiceAddress2] = useState(
    setting.address2 ? setting.address2 : ""
  );
  const [invoiceAddress3, setInvoiceAddress3] = useState(
    setting.address3 ? setting.address3 : ""
  );
  const [invoiceCountry, setInvoiceCountry] = useState(
    setting.country ? findArray(setting.country) : ""
  );
  const [invoiceText, setInvoiceText] = useState(
    setting.invoiceText ? setting.invoiceText : ""
  );
  const [invoiceFooter, setInvoiceFooter] = useState(
    setting.invoiceFooter ? setting.invoiceFooter : ""
  );
  const [errors, setErrors] = useState({});

  const invoiceSchema = Yup.object().shape({
    address1: Yup.string().max(150, 'Must be 150 characters or less'),
    address2: Yup.string().max(150, 'Must be 150 characters or less'),
    address3: Yup.string().max(150, 'Must be 150 characters or less'),
    invoiceDueDate: Yup.number().required('Due date is a required field')
      .positive('Must be a positive number')
      .integer('Must be a integer number')
      .typeError('Must be a number'),
    invoiceFooter: Yup.string().max(500, 'Must be 500 characters or less'),
    invoiceText: Yup.string().max(900, 'Must be 900 characters or less'),
    country: Yup.string().required("Country is a required field").max(30, 'Must be 30 characters or less'),
    senderName: Yup.string().max(50, 'Must be 50 characters or less'),
  });

  const handleSave = (e) => {
    e.preventDefault();
    const data = {
      invoiceSettings: {
        address1: invoiceAddress1,
        address2: invoiceAddress2,
        address3: invoiceAddress3,
        invoiceDueDate: Number(invoiceDate),
        invoiceFooter: invoiceFooter,
        invoiceText: invoiceText,
        country: invoiceCountry?.label || "",
        senderName: invoiceSenderName,
      },
    };

    invoiceSchema
      .validate(data.invoiceSettings, { abortEarly: false })
      .then(valid => {
        // console.log(valid);
        setErrors({});
        dispatch(editInvoiceSettings(data));
      })
      .catch(err => {
        if (err.inner && err.inner.length > 0) {
          const formattedErrors = err.inner.reduce((acc, validationError) => {
            if (!acc[validationError.path]) {
              acc[validationError.path] = validationError.message;
            }
            return acc;
          }, {});
          setErrors(formattedErrors);
        } else {
          setErrors({ general: err.message }); // generic error, outside the fields.
        };
      });
  };

  return (
    <div mt-1>
      <div className="pb-2 d-flex flex-direction-column">
        <h2 className={styles.settings__header}>Invoice Settings</h2>
      </div>
      <Form onSubmit={handleSave} autoComplete="off" className={styles.settings_wrapper}>
        <div
          className={`input-group d-sm-flex d-block mb-3 ${styles.input_group}`}
        >
          <div className="input-group-prepend">
            <label
              className={`input-group-text ${styles.input_group_text}`}
              htmlFor="capBookingWindow"
            >
              Due date:
            </label>
          </div>
          <div>
            <div className={`d-flex mt-m mt-sm-0`}>
              <div>
                <input
                  type="number"
                  className={`form-control ${styles.numberOfField}`}
                  id="invoiceDate"
                  name={"invoiceDate"}
                  min="0"
                  max="180"
                  value={invoiceDate}
                  onChange={(e) => setInvoiceDate(e.target.value)}
                />
              </div>
              <div className={"mx-3 align-self-end"}>
                <label htmlFor="invoiceDate">
                  {" "}
                  &nbsp;&nbsp;days after invoice date
                </label>
              </div>
            </div>
            <div  className={errors.invoiceDueDate ? styles.form_error : styles.form_error_hidden}>{errors.invoiceDueDate}</div>
          </div>
        </div>
        <Form.Row className="pb-2">
          <Form.Label className="col-sm-12 col-form-label pl-1 mb-2 pl-sm-3">
            <b>Sender: </b>
          </Form.Label>
          <Form.Label
            className={`col-4 col-form-label pl-1 pl-sm-3 ${styles.defaultFont}`}
          >
            Name:{" "}
          </Form.Label>
          <div className={`col-8 ${styles.defaultFont}`}>
            <Form.Control
              type="text"
              value={invoiceSenderName}
              onChange={(e) => setInvoiceSenderName(e.target.value)}
              style={{ fontSize: "inherit" }}
            />
            <div  className={errors.name ? styles.form_error : styles.form_error_hidden}>{errors.name}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label
            className={`col-4 col-form-label pl-1 pl-sm-3 ${styles.defaultFont}`}
          >
            Address 1:{" "}
          </Form.Label>
          <div className={`col-8 ${styles.defaultFont}`}>
            <Form.Control
              type="text"
              value={invoiceAddress1}
              onChange={(e) => setInvoiceAddress1(e.target.value)}
              style={{ fontSize: "inherit" }}
            />
            <div  className={errors.address1 ? styles.form_error : styles.form_error_hidden}>{errors.address1}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label
            className={`col-4 col-form-label pl-1 pl-sm-3 ${styles.defaultFont}`}
          >
            Address 2:{" "}
          </Form.Label>
          <div className={`col-8 ${styles.defaultFont}`}>
            <Form.Control
              type="text"
              value={invoiceAddress2}
              onChange={(e) => setInvoiceAddress2(e.target.value)}
              style={{ fontSize: "inherit" }}
            />
            <div  className={errors.address2 ? styles.form_error : styles.form_error_hidden}>{errors.address2}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label
            className={`col-4 col-form-label pl-1 pl-sm-3 ${styles.defaultFont}`}
          >
            Address 3:{" "}
          </Form.Label>
          <div className={`col-8 ${styles.defaultFont}`}>
            <Form.Control
              type="text"
              value={invoiceAddress3}
              onChange={(e) => setInvoiceAddress3(e.target.value)}
              style={{ fontSize: "inherit" }}
            />
            <div className={errors.address3 ? styles.form_error : styles.form_error_hidden}>{errors.address3}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label
            className={`col-4 col-form-label pl-1 pl-sm-3 ${styles.defaultFont}`}
          >
            Country:{" "}
          </Form.Label>
          <div className={`col-8 ${styles.defaultFont}`}>
            <Select
              options={countryList().getData()}
              onChange={(val) => setInvoiceCountry(val)}
              value={invoiceCountry}
              isClearable={true}
              onError={!!errors.country}
            />
            <div className={errors.country ? styles.form_error : styles.form_error_hidden}>{errors.country}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label className="col-sm-12 col-form-label pl-1 pl-sm-3">
            <b>Invoice text:</b>
          </Form.Label>
          <div className="col-sm-12">
            <Form.Control
              className={`ml-sm-3 ${styles.defaultFont}`}
              as="textarea"
              value={invoiceText}
              onChange={(e) => setInvoiceText(e.target.value)}
              rows={4}
              name="invoiceText"
            />
            <div className={`ml-sm-3 ${errors.invoiceText ? styles.form_error : styles.form_error_hidden}`}>{errors.invoiceText}</div>
          </div>
        </Form.Row>
        <Form.Row className="pb-2">
          <Form.Label className="col-sm-12 col-form-label pl-1 pl-sm-3">
            <b>Footer information: </b>
          </Form.Label>
          <div className="col-sm-12">
            <Form.Control
              className={`ml-sm-3 ${styles.defaultFont}`}
              as="textarea"
              value={invoiceFooter}
              onChange={(e) => setInvoiceFooter(e.target.value)}
              rows={4}
              name="invoiceFooter"
            />
            <div  className={`ml-sm-3 ${errors.invoiceFooter ? styles.form_error : styles.form_error_hidden}`}>{errors.invoiceFooter}</div>
          </div>
        </Form.Row>{" "}
        <div className="d-flex justify-content-start">
          <button className={styles.settings_save} type="submit">
            Save Changes
          </button>
        </div>
      </Form>
    </div>
  );
}

export default Invoice;
